import { getOfficeData } from '@/lib/api/use-get-data'
import apiStatus from '@/lib/api-status'

export const getCuurentOfficeData = async () => {
  const officeId = document.cookie.replace(
    /(?:(?:^|.*;\s*)office_id\s*=\s*([^;]*).*$)|^.*$/,
    '$1'
  )
  const responsePromise = await getOfficeData(officeId)
  if (!responsePromise) return
  const isStatus = apiStatus.statusHandring(responsePromise.data.meta)
  if (!isStatus) {
    alert('データを正常に取得できませんでした。リロードします。')
    location.reload()
    return
  }
  const officeArray = responsePromise.data.data
  const currentOfficeArray = officeArray.filter(
    (element: any) => element.id === officeId
  )
  return currentOfficeArray[0]
}

export const getCurrentOfficeAndUnitData = async () => {
  const officeId = document.cookie.replace(
    /(?:(?:^|.*;\s*)office_id\s*=\s*([^;]*).*$)|^.*$/,
    '$1'
  )
  const responsePromise = await getOfficeData(officeId)
  if (!responsePromise) return
  const isStatus = apiStatus.statusHandring(responsePromise.data.meta)
  if (!isStatus) {
    alert('データを正常に取得できませんでした。リロードします。')
    location.reload()
    return
  }
  const officeArray = responsePromise.data.data
  return officeArray
}
